const Footer=()=>{
    return (<div>
        Patients Footer Interface
    </div>)
}

export default Footer;